import { useState } from 'react'

import { Box, IconButton, TextField, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'

const useStyles = makeStyles((theme) => ({
  searchBox: {
    display: 'flex',
    '& button': {
      alignSelf: 'flex-end',
    },
  },
  searchSubBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  searchInputRoot: {
    minWidth: '200px',
    backgroundColor: 'white',
    maxWidth: '100%',
    margin: `${theme.spacing(1)}px 0`,
    [theme.breakpoints.up('sm')]: {
      margin: `0 ${theme.spacing(1)}px`,
    },
  },
}))
interface props {
  firstName: string
  lastName: string
  onSubmit: (firstName: string, lastName: string) => void
}

export const FirstLastNameSearch = ({ firstName, lastName, onSubmit }: props) => {
  const classes = useStyles()
  const [firstNameSearch, setFirstNameSearch] = useState(firstName)
  const [lastNameSearch, setLastNameSearch] = useState(lastName)

  return (
    <form
      aria-labelledby="fln-search-form-label"
      id="fln-search-form"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit(firstNameSearch.trim(), lastNameSearch.trim())
      }}
      autoComplete="on"
    >
      <Box className={classes.searchBox}>
        <Box className={classes.searchSubBox}>
          <Typography id="fln-search-form-label">Search by name</Typography>
          <TextField
            className={classes.searchInputRoot}
            value={firstNameSearch}
            id="fln-FirstNameSearch"
            label="First Name"
            variant="outlined"
            size="small"
            autoComplete="given-name"
            onChange={(e) => setFirstNameSearch(e.target.value)}
          />
          <TextField
            className={classes.searchInputRoot}
            value={lastNameSearch}
            id="fln-LastNameSearch"
            label="Last Name"
            variant="outlined"
            size="small"
            autoComplete="family-name"
            onChange={(e) => setLastNameSearch(e.target.value)}
          />
        </Box>
        <IconButton
          color="primary"
          type="submit"
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      </Box>
    </form>
  )
}
